import React from 'react';
import '../less/general.less';
import '../../../less/strategy'
import advantages_1_data from '../enums/advantages_1_data.json';
import advantages_2_data from '../enums/advantages_2_data.json';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock/views/Advantages';
import tariffs_1_data from '../enums/tariffs_1_data.json';
import tariffs_2_data from '../enums/tariffs_2_data.json';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock/views/Tariffs.c';
import Tabs from '../../../../../auxiliary-components/shared/Tabs/views/Tabs.c';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock/views/TitleBlock';
import TextBlock from '../../../../../auxiliary-components/shared/TextBlock/views/TextBlock';
import Stakeholders from '../../stakeholders';
import Top from '../../../views/top.c';
import Strategy from '../../../views/strategy.c';
import Esg from '../../../views/esg.c';
import { govUaGLOBUS, govUaMoneyGram, govUaRia, govUaVisa, govUaMasterCard, govUaProstir, govUaWU, govUaIntelExpress, govUaSEP,aboutGeneralPeopleRating, aboutGeneralStabilityRating, aboutGeneralCapitalRating, aboutGeneralDepositsRating, aboutGeneralCardsRating, aboutGeneralCreditRating, aboutGeneralAbank24Rating, aboutGeneralCreditCardsAmount, aboutGeneralBranchesAmount, aboutGeneralDepositorsAmount, aboutGeneralCardsAmount, dynamoLink } from "../../../../../services/urls/urls";
import hint_data from '../enums/hint_data.json';
import partner_hero_img from '../img/partner_hero_img.png';
import partner_hero_data from '../enums/partner_hero_data.json';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';

export default function template() {

    const isMobile = this.isViewportMobile(),
        {viewport} = this.props,
        tabs = [
            {tab: 'general', title: 'HEADER_LINK_GENERAL'},
            {tab: 'for-stakeholders', title: 'STAKEHOLDERS_NAV_TITLE'},
            {tab: 'top', title: 'HEADER_LINK_TOP'},
            {tab: 'strategy', title: 'HEADER_LINK_STRATEGY'},
            {tab: 'partner', title: 'ABOUT_NEW_TABS_PARTNER'},
            {tab: 'esg', title: 'ABOUT_NEW_TABS_ESG'}
        ],
        page = 'about_general';

    const linksMap = {
        aboutGeneralPeopleRating,
        aboutGeneralStabilityRating,
        aboutGeneralCapitalRating,
        aboutGeneralDepositsRating,
        aboutGeneralCardsRating,
        aboutGeneralCreditRating,
        aboutGeneralAbank24Rating,
        aboutGeneralCardsAmount,
        aboutGeneralBranchesAmount,
        aboutGeneralDepositorsAmount
    };

    const hintLinksMap = {
        govUaVisa,
        govUaMasterCard,
        govUaProstir,
        govUaWU,
        govUaRia,
        govUaMoneyGram,
        govUaGLOBUS,
        govUaIntelExpress,
        govUaSEP,
        dynamoLink
    };

    const mapTariffsData = data =>
        data.map(item => ({
            ...item,
            values: Array.isArray(item.values)
                ? item.values.map(val => {
                      if (val.type === 'button') {
                          return {
                              ...val,
                              btnLink: linksMap[val.btnLink],
                          };
                      }

                      return val;
                  })
                : []
        }));

    const tariffs1Data = mapTariffsData(tariffs_1_data);
    const tariffs2Data = mapTariffsData(tariffs_2_data);

    const partnerHeroData = {
      ...partner_hero_data,
      link: {
        ...partner_hero_data.link,
        href: hintLinksMap[partner_hero_data.link.href],
      },
    };

    return (
      <div className="about">
          <Tabs tabs={tabs} tab={this.state.mode} toggle={this.toggleMode} page={'about'}>
            <div className='general wrapper'>
              <div className='content'>
                  <div className='container'>
                      <TitleBlock title='GENERAL_TITLE' tag='h4' />
                      <Advantages title={'GENERAL_USAGE_BLOCK_01_TEXT'} items={advantages_1_data.items} itemTitleTag='h2' />
                  </div>
                <Tariffs
                  items={tariffs1Data}
                  title={'GENERAL_TITLE_TABLE_1'}
                  page={page}
                />
                <Tariffs
                  items={tariffs2Data}
                  title={'GENERAL_TITLE_TABLE_2'}
                  page={page}
                />
                <Advantages items={advantages_2_data.items} title='GENERAL_USAGE_BLOCK_2_TITLE' subtitle={'GENERAL_USAGE_BLOCK_2_SUBTITLE'} itemTitleTag='h2' className="general-about-ratings"/>
                <div className='general-hint'>
                  <TitleBlock title={isMobile ? 'GENERAL_HINT_TITLE_MOB' : 'GENERAL_HINT_TITLE'} tag='h4' />
                  {hint_data.map((group, idx) => (
                      <React.Fragment key={idx}>
                          {group.texts.map(text => (
                              <TextBlock key={text} text={text} />
                          ))}
                          <a className="general-hint-btn-link" href={hintLinksMap[group.link.href]} target="_blank" rel="noreferrer">
                              {this.l10n(group.link.label)}
                          </a>
                      </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
            <div className="wrapper content">
              <Stakeholders {...this.props} />
            </div>
            <div className="wrapper content">
              {this.state.mode === 'top' ? <Top {...this.props} /> : ''}
            </div>
            <div className="wrapper content">
              {this.state.mode === 'strategy' ? <Strategy {...this.props} /> : ''}
            </div>
            <div className="partner-wrapper">
              {this.state.mode === 'partner' && (
                <Hero data={partnerHeroData} img={partner_hero_img} />
              )}
            </div>
            {this.state.mode === 'esg' && <Esg {...this.props} />}
          </Tabs>
      </div>


    );
}
